<script>
import appConfig from '@src/app.config.json'
import Axios from '@plugin/axios.js'
export default {
  data() {
    return {
      reports: [],
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      footerInfo: [],
    }
  },
  watch: {
    '$i18n.locale': function() {
      this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id'
      this.getMenu()
      this.getReportFiles()
    },
  },
  async mounted() {
    await this.getReportFiles()
    await this.getMenu()
  },
  methods: {
    getReportFiles: function() {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'report-files',
        simple: true,
        lang: this.lang,
        // taxonomy_show: false,
      }
      /** params need to encoded from object to url params */
      params = Object.keys(params)
        .map(function(key) {
          return key + '=' + params[key]
        })
        .join('&')
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      /** define endpoint */
      var endpoint = `${appConfig.endpoint}/klaster-by-member-relation?${params}`
      // get the news
      Axios.get(endpoint, getOptions).then((response) => {
        const data = response.data.data
        // after successfull response, we should then update the menuItems on data() above
        if (response.data) {
          this.reports = data
        }
      })
    },
    getMenu: function(location = 'Description') {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'menu',
        attribute_show: false,
        taxonomy_show: false,
        lang: this.lang,
        simple: true,
      }
      /** loop param then push to params */
      var param = {
        attribute: {
          section: location,
        },
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      Axios.get(endpoint).then((response) => {
        const data = response.data.data
        // console.log(data)
        if (data) {
          this.footerInfo = data
        }
      })
    },
    getImgUrl(pic) {
      return require('@assets/' + pic)
    },
    /**
     * It should be filters, but method is also works
     */
    s3: function(path) {
      return appConfig.s3_endpoint + path
    },
    /**
     * Download handler from backend
     */
    download: function(id) {
      // return appConfig.download_handler + id
      window.location = appConfig.download_handler + id
    },
  },
}
</script>

<template>
  <footer :class="$style.footer">
    <b-container>
      <b-row>
        <b-col cols="lg-4" :class="$style.aboutFooter">
          <img v-lazy="getImgUrl('icons/Lexikan_500px_Putih.png')" alt="" />
          <span
            v-if="footerInfo.length !== 0"
            v-html-safe="footerInfo[0].content"
          ></span>
        </b-col>
        <!-- empty cols -->
        <b-col></b-col>
        <b-col cols="lg-6" :class="$style.executiveSummary">
          <h4>{{ $t('Executive Summary & Full Report') }}</h4>
          <div :class="$style.reports">
            <div
              v-for="(report, index) in reports"
              :key="index"
              style="display: contents"
            >
              <img
                v-if="
                  report.atribut.length !== 0 &&
                    report.atribut.featured_image.data.length !== 0
                "
                v-lazy="s3(report.atribut.featured_image.data[0].content)"
                pointer
                alt="full_reports"
                @click="download(report.atribut.file.data[0].ID)"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row :class="$style.footerBottom">
        <b-col cols="lg-6">
          <span
            v-if="footerInfo.length !== 0"
            v-html-safe="footerInfo[1].content"
            :class="$style.copyrightText"
          ></span>
        </b-col>
        <b-col cols="lg-6">
          <ul :class="$style.footerMenu">
            <li class="d-none"><a href="">Privacy Policy</a></li>
            <li
              ><router-link to="/tou">{{
                $t('Terms & Conditions')
              }}</router-link></li
            >
            <li><router-link to="/faq">FAQ</router-link></li>
            <li>
              <router-link :to="$t('about')">{{ $t('about_us') }}</router-link>
            </li>
            <li>
              <router-link :to="$t('contact')">{{ $t('contact') }}</router-link>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<style lang="scss" module>
@import '@design';
.footer {
  padding: 3rem 2rem;
  background-color: $dark;
  * {
    color: $white;
  }
  .aboutFooter {
    img {
      display: block;
      width: 65%;
    }
    span {
      display: flex;
      margin: 2rem 0;
      font-size: 1.25em;
    }
  }
  .executiveSummary {
    margin-top: 1rem;
    h4 {
      position: relative;
      font-weight: $content-font-weight;
      &::after {
        position: absolute;
        bottom: -1rem;
        left: 0;
        width: 3rem;
        height: 3px;
        content: '';
        border-bottom: 3px solid $primary;
      }
    }
    .reports {
      margin: 3rem 0;
      img {
        width: 10rem;
        margin-right: 1.5rem;
      }
    }
  }
  .copyrightText {
    font-weight: $light;
  }
  .footerMenu {
    display: flex;
    justify-content: space-between;
    padding-left: 0;
    overflow-x: auto;
    li {
      list-style: none;

      a {
        color: $white;
      }
    }
  }
}
@media only screen and (max-width: $mobile-sm) {
  .footer {
    .executiveSummary {
      .reports {
        display: flex;
        img {
          width: 49%;
          margin-right: 2%;
        }
      }
    }
    .footerBottom {
      flex-direction: column-reverse;
      .footerMenu {
        flex-wrap: wrap;
        justify-content: normal;
        li {
          margin: 0.5rem 1rem 0.5rem 0;
        }
      }
    }
  }
}
</style>
